import React from "react";
import "./PromotionsSection.scss";

const PromotionsSection = () => {
  const promotions = [
    {
      title: "Descuentos especiales por temporada",
      text: "Encuentra promociones exclusivas con proveedores seleccionados para hacer más accesible la fiesta que imaginas.",
      badge: "Oferta especial",
    },
    {
      title: "Paquetes para tus XV años",
      text: "Descubre opciones que combinan varios servicios para ayudarte a organizar tu evento de forma más práctica y conveniente.",
      badge: "Paquetes",
    },
    {
      title: "Promociones limitadas",
      text: "Aprovecha oportunidades disponibles por tiempo limitado y encuentra propuestas atractivas para tu gran día.",
      badge: "Tiempo limitado",
    },
  ];

  return (
    <section className="promotionsDreams">
      <div className="container">
        <div className="promotionsDreams__header">
          <span className="promotionsDreams__tag">Oportunidades para aprovechar</span>
          <h2>Aprovecha promociones exclusivas</h2>
          <p>
            Descubre ofertas, paquetes y beneficios especiales que pueden ayudarte
            a encontrar mejores opciones para celebrar unos XV años inolvidables.
          </p>
        </div>

        <div className="promotionsDreams__grid">
          {promotions.map((promo, index) => (
            <article className="promotionsDreams__card" key={index}>
              <span className="promotionsDreams__badge">{promo.badge}</span>
              <h3>{promo.title}</h3>
              <p>{promo.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionsSection;